import React from "react";
import { Link } from "react-router-dom";
import { __ } from "services/Translator";

export default function BottomBanner(props) {
  return (
    <section className="banner_bottom">
      <div className="container-xxl">
        <div className="banner_image">
          {props.landingType === "poker" && !props.isMobileDeviceByViewPort && (
            <img
              alt="game image"
              src="https://chimpbytes.imgix.net/banner-bottom-poker-bg.png?&dpr=1&format=auto&auto=format&w=1296&h=527&max-age=2629056"
            />
          )}
          {props.landingType === "poker" && props.isMobileDeviceByViewPort && (
            <img
              alt="game image"
              src={
                require("assets/images/banners/coins_glass-mobile.png").default
              }
            />
          )}
          {props.landingType === "sport" && !props.isMobileDeviceByViewPort && (
            <img
              alt="game image"
              src="https://chimpbytes.imgix.net/banner-bottom-sport-bg.png?&dpr=1&format=auto&auto=format&w=1296&h=527&max-age=2629056"
            />
          )}
          {props.landingType === "sport" && props.isMobileDeviceByViewPort && (
            <img
              alt="game image"
              src={
                require("assets/images/banners/coins_glass-mobile.png").default
              }
            />
          )}
          {props.landingType === "bingo" && !props.isMobileDeviceByViewPort && (
            <img
              alt="game image"
              src="https://chimpbytes.imgix.net/banner-bottom-poker-bg.png?&dpr=1&format=auto&auto=format&w=1296&h=527&max-age=2629056"
            />
          )}
          {props.landingType === "bingo" && props.isMobileDeviceByViewPort && (
            <img
              alt="game image"
              src={
                require("assets/images/banners/coins_glass-mobile.png").default
              }
            />
          )}
          {props.landingType === "casino" &&
            !props.isMobileDeviceByViewPort && (
              <img
                alt="game image"
                src="https://chimpbytes.imgix.net/banner-bottom-home-bg.png?&dpr=1&format=auto&auto=format&w=1296&h=527&max-age=2629056"
              />
            )}
          {props.landingType === "casino" && props.isMobileDeviceByViewPort && (
            <img
              alt="game image"
              src={
                require("assets/images/banners/coins_glass-mobile.png").default
              }
            />
          )}

          <div className="text_block">
            <div className="title italic">{__("GET YOUR WELCOME PACKAGE")}</div>

            <div className="title heading padding_bottom_0">
              {__("100% Monthly Bonus")}
            </div>
            <div className="title heading padding_top_0">
              {__("of your Deposit.")}
            </div>

            {props.isAuthenticated ? (
              <Link
                to="/games/slots"
                className={"angle_btn " + props.landingType}
              >
                {__("Play Now")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="red"
                  class="bi bi-arrow-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </Link>
            ) : (
              <Link
                onClick={() => {
                  props.setModalSignUpPropsData(true);
                }}
                className={"angle_btn " + props.landingType}
              >
                {__("Claim Your Bonus")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="red"
                  class="bi bi-arrow-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
